// map camelCase names to display names
export const nameMap: Record<string, string> = {
  transactionCountByBankCcAccount: 'Transaction Count by Bank & CC Account',
  nonNumericChecks: 'Non-numeric Checks',
  billPaymentCheck: 'Bill Payment (Check)',
  billPaymentCreditCard: 'Bill Payment (Credit Card)',
  profitAndLossVariance: 'Profit & Loss Variance',
  monthEndClose: 'Month-end Close',
}
